/**
 * Safe localStorage wrapper for Zustand persist middleware
 * Handles quota exceeded errors and browser storage restrictions gracefully
 */

export const createSafeStorage = () => ({
  getItem: (name: string) => {
    try {
      const str = localStorage.getItem(name);
      return str ? JSON.parse(str) : null;
    } catch (error) {
      console.error(`Error reading from localStorage (${name}):`, error);
      return null;
    }
  },
  setItem: (name: string, value: unknown) => {
    try {
      localStorage.setItem(name, JSON.stringify(value));
    } catch (error) {
      console.error(`Error writing to localStorage (${name}):`, error);
      // If quota exceeded, try to clear old data
      if (error instanceof Error && error.name === 'QuotaExceededError') {
        console.warn('localStorage quota exceeded, attempting to clear old data');
        try {
          // Clear test history if it exists to free up space
          localStorage.removeItem('enneagram-test-storage');
          // Try again
          localStorage.setItem(name, JSON.stringify(value));
        } catch (retryError) {
          console.error('Failed to write even after clearing data:', retryError);
        }
      }
    }
  },
  removeItem: (name: string) => {
    try {
      localStorage.removeItem(name);
    } catch (error) {
      console.error(`Error removing from localStorage (${name}):`, error);
    }
  },
});
